import React from 'react';

const App: React.FC = () => {
  const [activeBlock, setActiveBlock] = React.useState<string | null>(null);

  const serviceBlocks = [
    { 
      id: 'automation',
      desc: 'Automatizo processos complexos e fluxos de trabalho para aumentar a produtividade da sua empresa',
      icon: '⚡',
      color: '#00ff9d'
    },
    { 
      id: 'chatbot',
      desc: 'Desenvolvo chatbots inteligentes para atendimento automatizado e qualificação de leads',
      icon: '🤖',
      color: '#ffbd2e'
    },
    { 
      id: 'website',
      desc: 'Crio websites profissionais e sistemas web personalizados com foco em resultados',
      icon: '🌐',
      color: '#ff69b4'
    },
    { 
      id: 'integration',
      desc: 'Integro diferentes plataformas e APIs para criar soluções completas de negócio',
      icon: '🔄',
      color: '#00ffff'
    }
  ];

  const socialLinks = [
    {
      id: 'github',
      name: 'GitHub',
      url: 'https://github.com/ruthesdev',
      icon: (
        <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
          <path fillRule="evenodd" d="M12 2C6.477 2 2 6.484 2 12.017c0 4.425 2.865 8.18 6.839 9.504.5.092.682-.217.682-.483 0-.237-.008-.868-.013-1.703-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.531 1.032 1.531 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.029-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0112 6.844c.85.004 1.705.115 2.504.337 1.909-1.296 2.747-1.027 2.747-1.027.546 1.379.202 2.398.1 2.651.64.7 1.028 1.595 1.028 2.688 0 3.848-2.339 4.695-4.566 4.943.359.309.678.92.678 1.855 0 1.338-.012 2.419-.012 2.747 0 .268.18.58.688.482A10.019 10.019 0 0022 12.017C22 6.484 17.522 2 12 2z" clipRule="evenodd" />
        </svg>
      ),
      bgColor: 'bg-gray-900',
      hoverColor: 'hover:bg-gray-800'
    },
    {
      id: 'instagram',
      name: 'Instagram',
      url: 'https://instagram.com/ruthesdev',
      icon: (
        <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
          <path fillRule="evenodd" d="M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.597 0 2.917-.01 3.96-.058.976-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041v-.08c0-2.597-.01-2.917-.058-3.96-.045-.976-.207-1.505-.344-1.858a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.802a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z" clipRule="evenodd" />
        </svg>
      ),
      bgColor: 'bg-pink-600',
      hoverColor: 'hover:bg-pink-500'
    },
    {
      id: 'email',
      name: 'Email',
      url: 'mailto:jefter@ruthes.dev',
      icon: (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
        </svg>
      ),
      bgColor: 'bg-blue-600',
      hoverColor: 'hover:bg-blue-500'
    }
  ];

  return (
    <main className="min-h-screen bg-gradient-to-b from-[#0a0f1c] to-[#1a1b26] text-white">
      <div className="container mx-auto px-4 py-12 min-h-screen flex flex-col justify-center">
        <div className="max-w-4xl mx-auto w-full space-y-12">
          {/* Header */}
          <header className="text-center">
            <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-[#ffbd2e] mb-4">
              /Ruthes
            </h1>
            <div className="flex items-center justify-center space-x-2 text-[#00ff9d]">
              <span className="inline-block w-2 h-2 bg-[#00ff9d] rounded-full animate-pulse"></span>
              <span className="text-lg">Low-Code Developer</span>
            </div>
          </header>

          {/* Service Blocks Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {serviceBlocks.map((block) => (
              <div
                key={block.id}
                className="group relative bg-[#1e1f2e]/80 backdrop-blur-sm rounded-lg p-6 border border-[#2a2b3c] hover:border-[var(--hover-color)] transition-all duration-300"
                onMouseEnter={() => setActiveBlock(block.id)}
                onMouseLeave={() => setActiveBlock(null)}
                style={{
                  '--hover-color': block.color
                } as React.CSSProperties}
              >
                <div className="flex items-start space-x-4">
                  <div className="text-4xl">{block.icon}</div>
                  <p className="text-gray-300 leading-relaxed">{block.desc}</p>
                </div>
                <div className={`absolute inset-0 bg-[var(--hover-color)]/5 rounded-lg transition-opacity duration-300 ${activeBlock === block.id ? 'opacity-100' : 'opacity-0'}`}></div>
                <div className="absolute -bottom-1 left-0 w-full h-[2px] bg-gradient-to-r from-transparent via-[var(--hover-color)] to-transparent transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300"></div>
              </div>
            ))}
          </div>

          {/* Social Links Grid */}
          <div className="grid grid-cols-3 gap-4">
            {socialLinks.map((social) => (
              <a
                key={social.id}
                href={social.url}
                target="_blank"
                rel="noopener noreferrer"
                className={`group relative flex items-center justify-center p-4 rounded-lg ${social.bgColor} ${social.hoverColor} transition-all duration-300`}
              >
                <div className="flex flex-col items-center space-y-2">
                  {social.icon}
                  <span className="text-sm font-medium">{social.name}</span>
                </div>
                <div className="absolute inset-0 bg-white/10 rounded-lg opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </main>
  );
};

export default App; 